import React from "react";
import classes from "./classes.module.scss";
import Typography, { ETypo } from "@Front/Components/DesignSystem/Typography";
import Form from "@Front/Components/DesignSystem/Form";
import TextField from "@Front/Components/DesignSystem/Form/TextField";
import Button, { EButtonVariant } from "@Front/Components/DesignSystem/Button";
import { ValidationError } from "class-validator";
import { DeliveryChannel } from "@Front/Api/Auth/Customer/Auth";
import { useSiteTextContent } from "@Front/Stores/SiteTextsContext";
import { useStepTotpResendCooldown } from "./hooks/useStepTotpResendCooldown";
import { useStepTotpDeliveryMessage } from "./hooks/useStepTotpDeliveryMessage";
import { StepTotpResendBlock } from "./components/StepTotpResendBlock";
import SiteConfigDisplayNameLine from "@Front/Components/Layouts/Common/SiteConfigDisplayNameLine";

type IProps = {
	onSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: { [key: string]: string }) => void;
	validationErrors: ValidationError[];
	partialPhoneNumber: string;
	deliveryChannel: DeliveryChannel;
	maskedEmail?: string;
	email: string;
	onSendAnotherCode: () => void;
	siteDisplayName: string | null;
};

export default function StepTotp(props: IProps): React.JSX.Element {
	const { onSubmit, validationErrors, partialPhoneNumber, deliveryChannel, maskedEmail, email, onSendAnotherCode, siteDisplayName } = props;
	const smsTitlePrefix = useSiteTextContent("login.stepTotp.title.prefix");
	const emailTitlePrefix = useSiteTextContent("login.stepTotp.email.title");
	const totpPlaceholder = useSiteTextContent("login.stepTotp.form.placeholder");
	const submitCta = useSiteTextContent("login.stepTotp.form.submit");
	const resendQuestion = useSiteTextContent("login.stepTotp.resend.question");
	const resendCta = useSiteTextContent("login.stepTotp.resend.cta");
	const resendTimer = useSiteTextContent("login.stepTotp.resend.timer");

	const cooldown = useStepTotpResendCooldown(onSendAnotherCode);
	const deliveryMessage = useStepTotpDeliveryMessage({
		deliveryChannel,
		maskedEmail,
		email,
		partialPhoneNumber,
		smsTitlePrefix,
		emailTitlePrefix,
	});

	return (
		<div className={classes["root"]}>
			<Typography typo={ETypo.DISPLAY_LARGE}>
				<div className={classes["title"]}>{deliveryMessage}</div>
			</Typography>
			<SiteConfigDisplayNameLine siteDisplayName={siteDisplayName} />
			<Form className={classes["form"]} onSubmit={onSubmit}>
				<TextField
					placeholder={totpPlaceholder}
					name="totpCode"
					validationError={validationErrors.find((error) => error.property === "totpCode")}
				/>
				<Button type="submit" variant={EButtonVariant.PRIMARY} className={classes["submit_button"]}>
					{submitCta}
				</Button>
			</Form>
			<StepTotpResendBlock resendQuestion={resendQuestion} resendCta={resendCta} resendTimer={resendTimer} cooldown={cooldown} />
		</div>
	);
}
